import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

const elements = document.getElementsByClassName("sktreact");

for (var i = 0; i < elements.length; i++) {
  const el = elements[i];
  console.log(el);
  const attrs = el.getAttributeNames().reduce((prev, now) => {
    prev[now.replace("skt_", "")] = el.getAttribute(now);
    return prev;
  }, {});
  console.log(attrs);

  ReactDOM.render(
    <React.StrictMode>
      <App skt={attrs} />
    </React.StrictMode>,
    el
  );
}
